/** HeroUI's own look: the header on the grey rounded band, the rows in a white card. */
export const STOCK_TABLE_LOOK = {
  className: "stock-table--compact !h-full !min-h-0",
} as const;
